import React from "react";
import ChartSkeleton from "./ChartSkeleton";
import EmptyState from "./EmptyState";

const ErrorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4" />
    <circle cx="12" cy="16" r=".6" fill="currentColor" />
  </svg>
);

const Legend = ({ series, hidden, onToggle }) => {
  if (!series || series.length === 0) return null;
  return (
    <div className="rdc-frame__legend" role="group" aria-label="Series legend">
      {series.map((s) => {
        const isMuted = hidden && hidden.has(s.name);
        return (
          <button
            key={s.name}
            type="button"
            className={
              "rdc-legend-item" + (isMuted ? " rdc-legend-item--muted" : "")
            }
            onClick={() => onToggle && onToggle(s.name)}
            aria-pressed={!isMuted}
          >
            <span
              className="rdc-legend-item__swatch"
              style={{ background: s.color }}
            />
            <span>{s.name}</span>
          </button>
        );
      })}
    </div>
  );
};

const ChartFrame = ({
  title,
  subtitle,
  actions,
  series,
  hiddenSeries,
  onToggleSeries,
  loading,
  error,
  isEmpty,
  emptyTitle,
  emptyBody,
  children,
}) => {
  let content;
  if (loading) {
    content = <ChartSkeleton />;
  } else if (error) {
    content = (
      <EmptyState
        title="Could not load data"
        body={typeof error === "string" ? error : "Please try again."}
        icon={<ErrorIcon />}
      />
    );
  } else if (isEmpty) {
    content = <EmptyState title={emptyTitle} body={emptyBody} />;
  } else {
    content = children;
  }

  return (
    <section className="rdc-frame" aria-label={title}>
      <header className="rdc-frame__head">
        <div className="rdc-frame__titles">
          <h3 className="rdc-frame__title">{title}</h3>
          {subtitle && <p className="rdc-frame__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="rdc-frame__actions">{actions}</div>}
      </header>

      {!loading && !error && !isEmpty && (
        <Legend
          series={series}
          hidden={hiddenSeries}
          onToggle={onToggleSeries}
        />
      )}

      <div className="rdc-frame__body">{content}</div>
    </section>
  );
};

export default ChartFrame;
